import styled from 'styled-components';
import { motion } from 'framer-motion';
import { H1 } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Background = styled.div`
  position: relative;
  background-color: ${th('colors.turquoise')};
`;

export const StyledSafetyNet = styled.div`
  padding: 20px;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding: 100px;
  }
`;

export const Title = styled(H1)`
  font-family: ${th('fonts.headings')};
  font-weight: normal;
  font-size: 44px;
  line-height: 1;
  letter-spacing: initial;

  @media ${sizes.mobileMedium} {
    font-size: 48px;
  }

  @media ${sizes.mobileLarge} {
    font-size: 60px;
  }

  @media ${sizes.tabletPortrait} {
    font-size: 75px;
  }

  @media ${sizes.desktop} {
    font-size: 120px;
    line-height: 0.95;
  }

  @media ${sizes.extraLargeDesktop} {
    font-size: 150px;
  }

  @media ${sizes.monitor} {
    font-size: 170px;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1060px;
  margin-top: 28px;
  margin-bottom: 28px;

  @media ${sizes.tabletPortrait} {
    margin-top: 60px;
    flex-direction: row;
  }

  @media ${sizes.largeDesktop} {
    font-size: 20px;
  }

  @media ${sizes.extraLargeDesktop} {
    max-width: 980px;
  }

  @media ${sizes.monitor} {
    max-width: 1060px;
  }

  > * {
    flex: 1;
    line-height: 1.6;
  }

  > :first-child {
    margin-bottom: 20px;

    @media ${sizes.tabletPortrait} {
      margin-bottom: 0;
      margin-right: 40px;
    }
  }
`;

export const Team = styled(motion.div)`
  overflow-x: hidden;
  padding-top: 20px;
  > img {
    display: block;
    width: 100%;
    height: auto;
    transform-origin: bottom center;
  }
`;
